import { Input } from '@dynamika-shared/ui/Input/Input';
import { Select } from '@dynamika-shared/ui/Select/Select';
import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash';
import { UserRoles } from '@dynamika-shared/types/auth';
import { useParams } from 'react-router-dom';
import { FlattenOptionData } from 'rc-select/lib/interface';
import { BaseOptionType } from 'rc-select/lib/Select';
import { OptionMembersRenderer } from 'src/pages/ClinicalTrial/ClinicalTrialTeam/components/AddEditMember/OptionMembersRenderer';
import { useTeamMembersListSlice } from '@restore/teamMembersList/teamMembersList.slice';
import { useInventoryFormHandler } from '@hooks/useInventoryFormHandler';

export const Reader = () => {
  const { id: clinicalTrialId } = useParams<{
    id: string;
  }>();

  const [users, fetchUsers] = useTeamMembersListSlice((state, actions) => [
    state.data?.content || [],
    actions.fetchTeamMembersList,
  ]);
  const { onChange, onBlur, watch, errors } = useInventoryFormHandler();

  const [searchReaderValue, setSearchReaderValue] = useState<string>('');

  const readersOptions = useMemo(() => {
    return users.map(user => ({
      label: user.fullName,
      value: user.id,
    }));
  }, [users]);

  const readersOptionRenderer = (option: FlattenOptionData<BaseOptionType>) => (
    <OptionMembersRenderer
      searchValue={searchReaderValue}
      option={option}
      userMember={users.find(u => u.id === option.data.value)}
      selectedOptions={readersOptions.filter(u => u.value === watch('userId'))}
      hideActions
    />
  );

  const delayedSearch = useMemo(
    () =>
      debounce((name?: string) => {
        const role = UserRoles.READER;
        if (clinicalTrialId && role) {
          return fetchUsers({
            clinicalTrialId,
            args: {
              size: 100,
              page: 1,
              role,
              search: name,
            },
          });
        }
      }, 500),
    [clinicalTrialId]
  );

  useEffect(() => {
    if (clinicalTrialId) {
      fetchUsers({
        clinicalTrialId,
        args: {
          size: 100,
          page: 1,
          role: UserRoles.READER,
        },
      });
    }
  }, []);
  return (
    <>
      <Select
        showSearch
        searchValue={searchReaderValue}
        onSearch={value => {
          setSearchReaderValue(value);
          delayedSearch(value);
        }}
        label={'Dynamika User'}
        placeholder={'Dynamika User'}
        filterOption={false}
        listHeight={160}
        options={readersOptions}
        optionRender={readersOptionRenderer}
        onChange={value => onChange('dynamikaUserId', value)}
        value={watch('dynamikaUserId')}
        required
        data-testid='item-reader'
      />
      <Input
        required
        value={watch('alias')}
        name={'alias'}
        onChange={e => onChange('alias', e.target.value)}
        onBlur={e => onBlur('alias', e.target.value)}
        data-testid={'item-alias'}
        errors={errors.name?.message as string}
        label={'Alias'}
        placeholder={'Alias'}
        classNameInputWrapper='max-w-full'
      />
    </>
  );
};
